import { Box } from '@mui/material';

import DetailsItem from '../../../../../../common/details-item';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../../locales';
import { AirtimeReportDetailsMetadataResponse } from '../interfaces';

interface Props {
  filters: AirtimeReportDetailsMetadataResponse;
}

const DetailsSummary = ({ filters }: Props) => (
  <Box>
    <DetailsItem
      label={locales.common.filters.startingDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.from })}
    />
    <DetailsItem
      label={locales.common.filters.endDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
    />
    <DetailsItem
      label={locales.common.filters.operators.label}
      value={reportDetailsFilterValuesFormatter(filters.operators)}
    />
    <DetailsItem label={locales.common.filters.skus.label} value={reportDetailsFilterValuesFormatter(filters.skus)} />
    <DetailsItem
      label={locales.common.filters.statuses.label}
      value={reportDetailsFilterValuesFormatter(filters.statuses)}
    />
    <DetailsItem
      label={locales.common.filters.operationIds.label}
      value={reportDetailsFilterValuesFormatter(filters.operationIds)}
    />
    <DetailsItem
      label={locales.common.filters.acquirerMsisdns.label}
      value={reportDetailsFilterValuesFormatter(filters.acquirerMsisdns)}
    />
  </Box>
);

export default DetailsSummary;
